import {applyMiddleware, compose, createStore} from "redux";
import rootReducer from "./rootReducer";
import immutableStateInvariantMiddleware from "redux-immutable-state-invariant";


export default function configureStore(initialState?: any) {
    const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__  || compose;
    return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(immutableStateInvariantMiddleware())))
}